import React, { useState } from "react";
import RequestService from "../../services/request.service";

// import { Table, Form } from 'react-bootstrap'

import { toast } from 'react-toastify'

import Dialog from '../../services/Dialogs'

import { useNavigate, useParams } from 'react-router-dom';

// import moment from 'moment'

import { SERVER_ } from  '../../config';


import ModalInformeTramite from '../Mesa_Atencion/ModalInformeTramite'



const VerificarTramite = () =>{

  const dialog = new Dialog()

  let navigate = useNavigate()


  let { uuid_tramite } = useParams();

  const [ anexo_visualizar, setAnexoVisualizar ] = useState<string>('')


  const [ tramite, setTramite ] = useState<any>({ mi_tramite : false, tramite : {} })
  const verificarTramite = async () =>{
    try{
      let res = await RequestService.getEndPoint('verificacion_telefonica/tramite/'+uuid_tramite)
      setTramite(res.data)
    }
    catch(e){
      toast.error('Error al cargar los trámites para Verificación')
    }
  }


  React.useEffect(() => {
    verificarTramite()
  }, []);


  const finalizarVerificacionTelefonica = async(e) => {

    try{

        await dialog.open({
          accept: 'Finalizar',
          dialogClass: '',
          message: 'Finalizar con la verificación',
          soundAccept: 'https://assets.stoumann.dk/audio/accept.mp3',
          soundOpen: 'https://assets.stoumann.dk/audio/open.mp3',
          target: e.target,
          template: `
          <div><label class="form-label">Comentarios</label><textarea name="comentarios" class="form-control" rows="4"></textarea></div>

              <div class="mt-4">
              <label class="form-label">¿La Persona quiere proceder con el Trámite?</label>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="idestatus" value="2" id="flexRadioDefault1">
                  <label class="form-check-label" for="flexRadioDefault1">
                    Si
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="idestatus" value="3" id="flexRadioDefault2" >
                  <label class="form-check-label" for="flexRadioDefault2">
                    No
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="idestatus" value="4" id="flexRadioDefault3" >
                  <label class="form-check-label" for="flexRadioDefault3">
                    No se contactó
                  </label>
                </div>
              </div>

          `
        })
        let dialogo : any = await dialog.waitForUser()
        console.log(dialogo)
        if(dialogo && dialogo.idestatus){
          await RequestService.update('verificacion_telefonica/finalizar/'+uuid_tramite, dialogo )
          navigate("../verificaciones", { replace: true })
        }

    }
    catch(e){
      toast.error('Tuvimos problemas al intentar finalizar la verificación del trámite')
    }

  }



  // const [ uuid_tramite_modal, setUUIDTramiteSeleccionado ] = useState<any>('')
  const [ showModalInforme, setShowModalInforme ] = useState<boolean>(false)

  const onHideModalInforme = () =>{
    setShowModalInforme(false)
  }

  const fichaTramite = () => {
    // setUUIDTramiteSeleccionado(uuid_tramite)
    setShowModalInforme(true)
  }



      return (
             
          <>
              <div className="container">
                  
                  
                  <div className="row">
                    <div className="col-sm-6">
                      <h1>Verificación Telefónica</h1>
                    </div>
                    <div className="col-sm-6 d-grid gap-2">
                        {
                          tramite.mi_tramite && (

                                <button onClick={(e)=>{finalizarVerificacionTelefonica(e)}} className="btn btn-secondary btn-lg">Finalizar Verificación</button>

                          )
                        }
                    </div>
                  </div>

                  <hr />

                  <h6>Verificación de Trámite</h6>

                  {
                    !tramite.mi_tramite && (

                          <div className="alert alert-danger" role="alert">
                            <h4 className="alert-heading">Espera!</h4>
                            <p>No puedes atender este trámite</p>
                            <hr/>
                            <p className="mb-0">Por favor, intenta seleccionando otro Trámite para Verificación</p>
                          </div>

                    )
                  }

                  {
                    tramite.mi_tramite && (

                          <React.Fragment>
                            {
                              // JSON.stringify(tramite.tramite)
                            }

                            <div className="row">
                              <div className="col-sm-3">

                                <h5>Información del Cliente</h5>

                                <dl>
                                    <dt>Nombre</dt>
                                    <dd>{tramite.tramite.idciudadano.nombres} {tramite.tramite.idciudadano.paterno} {tramite.tramite.idciudadano.materno}</dd>
                                    <dt>Telefóno</dt>
                                    <dd>{tramite.tramite.idciudadano.telefono||'Sin proporcionar'}</dd>
                                    <dt>Celular</dt>
                                    <dd>{tramite.tramite.idciudadano.celular||'Sin proporcionar'}</dd>
                                    <dt>Correo Electrónico</dt>
                                    <dd>{tramite.tramite.idciudadano.email||'Sin proporcionar'}</dd>
                                </dl>


                              </div>
                              <div className="col-sm-3">

                                <h5>Información del Trámite</h5>

                              <dl>
                                  <dt>Folio</dt>
                                  <dd><p className="cursor" onClick={()=>{fichaTramite()}}>{tramite.tramite.folio}</p></dd>
                              </dl>

                                <h5>Información del Asesor</h5>

                              <dl>
                                  <dt>Nombre</dt>
                                  <dd>{tramite.tramite.idusuario.nombres} {tramite.tramite.idusuario.paterno} {tramite.tramite.idusuario.materno}</dd>
                                  <dt>Celular</dt>
                                  <dd>{tramite.tramite.idusuario.celular}</dd>
                              </dl>


                              </div>
                              <div className="col-sm-6">




                                      <div className="form-floating">
                                        <select className="form-select" value={anexo_visualizar} onChange={(e)=>{ setAnexoVisualizar(e.target.value) }} id="floatingSelect" aria-label="Floating label select example">
                                        <option disabled={anexo_visualizar===''?false:true} value="">Selecciona una opción</option>
                                          {
                                            tramite.anexos.map( (anexo:any, anexo_indice:number) =>

                                                <option key={anexo_indice} value={anexo.uuid} >
                                                  {
                                                    (anexo.idrequisito.requisito)
                                                  }
                                                </option>

                                            )
                                          }
                                        </select>
                                        <label htmlFor="floatingSelect">Anexo para visualizar</label>
                                      </div>


                                      <br />


                                      {
                                        anexo_visualizar !== "" && (
                                          <React.Fragment>
                                            <object width="100%" height="700px" data={SERVER_+'anexo/'+anexo_visualizar} type="application/pdf">
                                                <p>This browser does not support PDFs. Please download the PDF to view it: <a href="filename.pdf">Download PDF</a>.</p>
                                            </object>
                                          </React.Fragment>
                                        )
                                      }



                                
                              </div>
                            </div>


                          </React.Fragment>

                    )
                  }


              </div>



      {
        showModalInforme && (
            <ModalInformeTramite onHideModalInforme={onHideModalInforme} showModalInforme={showModalInforme} uuid_tramite={uuid_tramite} />
         )
      }



          </>

      );
  

}

export default VerificarTramite
